module.exports = __webpack_public_path__ + "img/mixerTruck-dark-grey.672a6ebb.svg";